/**
 * Skip-to-checkout helpers — also in snippets/titanore-skip-checkout.liquid (head).
 * Hoisted here so deferred custom.js defines them before DOMContentLoaded.
 */
(function () {
  function tlCookieCountry() {
    var m = document.cookie.match(/(?:^|; )localization=([^;]*)/);
    return m ? decodeURIComponent(m[1]).toUpperCase() : "";
  }
  function tlQueryCountry() {
    try {
      var c = (new URLSearchParams(location.search).get("country") || "").toUpperCase();
      if (c === "BE" || c === "NL") return c;
    } catch (err) {}
    return "";
  }
  function tlGeoCountry() {
    try {
      var g = (sessionStorage.getItem("tl_geo_country") || "").toUpperCase();
      if (g === "BE" || g === "NL") return g;
    } catch (err) {}
    return "";
  }
  function tlBuyerCountry() {
    var q = tlQueryCountry();
    if (q) return q;
    var geo = tlGeoCountry();
    if (geo) return geo;
    var c = tlCookieCountry();
    if (c === "BE" || c === "NL") return c;
    try {
      var sc = String(window.tlStoreCountry || (window.Shopify && Shopify.country) || "").toUpperCase();
      if (sc === "BE" || sc === "NL") return sc;
    } catch (err) {}
    return "";
  }
  window.tlBuyerCountry = tlBuyerCountry;
  window.tlCheckoutHref = function () {
    var p = (location.pathname || "").toLowerCase();
    var dutch = p === "/nl" || p.indexOf("/nl/") === 0;
    try {
      if (!dutch && document.documentElement && /^nl/i.test(document.documentElement.lang || "")) dutch = true;
    } catch (err) {}
    var country = tlBuyerCountry();
    if (country === "BE" || country === "NL") dutch = true;
    if (dutch) {
      var cc = country === "BE" ? "BE" : "NL";
      return "/nl/checkout?locale=nl&country=" + cc + "&skip_shop_pay=true";
    }
    return "/checkout?skip_shop_pay=true";
  };
  if (typeof window.tlAssignCheckout !== "function") {
    window.tlAssignCheckout = function () {
      location.assign(window.tlCheckoutHref());
    };
  };
  window.tlIsMetaWebView = function () {
    var ua = navigator.userAgent || "";
    return /FBAN|FBAV|FB_IAB|FBIOS|FB4A|FBSS|Instagram|Messenger|IABMV|\[FB_|FB_BW/i.test(ua);
  };
  window.tlIsAdsLanding = function () {
    var p = (location.pathname || "").toLowerCase();
    return (
      /\/pages\/chefs-pan-now(?:\/|$)/.test(p) ||
      /\/pages\/chefs-pan-b(?:\/|$)/.test(p) ||
      /\/collections\/chefs-pan-tommy(?:-b)?(?:\/|$)/.test(p)
    );
  };
  window.tlShouldSkipToCheckout = function () {
    /* Always false: FB/IG in-app must open the drawer, not hosted checkout. */
    return false;
  };
})();

/**
 * * end of cart upsell block part
 */
document.addEventListener("DOMContentLoaded", function () {
  const amountFreeProduct = document.querySelector("[data-treshold-product]")
    ? document.querySelector("[data-treshold-product]").getAttribute("data-treshold-product")
    : null;

  var cartTotalEl = document.querySelector(".gb-totals-total-value");
  var cart_total = cartTotalEl ? (cartTotalEl.textContent || "").trim() : "";
  if (amountFreeProduct > 0 && show_progress_bar) {
    const hasPremiumKit = document.querySelector(".premium-attachment-kit") !== null;
    if (hasPremiumKit) {
      console.log("Premium kit detected - skipping auto free gift trigger");
      return;
    }
    setTimeout(function () {
      var el = document.querySelector(".gb-totals-total-value");
      var cart_total = el ? (el.textContent || "").trim() : "";
      if (cart_total >= amountFreeProduct) {
        if (document.querySelector(".cart-item.gb-find-remove-product")) {
          console.log("Free product already in cart");
        } else {
          console.log("Adding free product");
          var trigger = document.querySelector(".gb-free-product-trigger");
          if (trigger) trigger.click();
        }
      } else {
        console.log("Removing free product - under threshold");
        var removeBtn = document.querySelector(".gb-remove-product");
        if (removeBtn) removeBtn.click();
      }
    }, 3000);

    document.body.addEventListener("click", function (e) {
      if (!e.target.closest(".gb-sumbit-free")) return;
      setTimeout(function () {
        var el = document.querySelector(".gb-totals-total-value");
        var cart_total = el ? (el.textContent || "").trim() : "";
        if (cart_total >= amountFreeProduct) {
          if (!document.querySelector(".cart-item.gb-find-remove-product")) {
            var trigger = document.querySelector(".gb-free-product-trigger");
            if (trigger) trigger.click();
          }
        } else {
          var removeBtn = document.querySelector(".gb-remove-product");
          if (removeBtn) removeBtn.click();
        }
      }, 3000);
    });
  }

  document.body.addEventListener("click", async function (e) {
    var label = e.target.closest && e.target.closest(".gb-shipping-protection-button label.switch");
    if (!label) return;
    if (e.target.tagName === "INPUT") return;
    const curElem = document.querySelector(".gb-shipping-protection-button label.switch");
    const curInputElem = document.querySelector(".gb-shipping-protection-button label.switch input");
    const spinAnim = document.querySelector(".gb-shipping-protection-button .spin-animation");
    const checkElem = document.querySelector(".gb-shipping-protection-button .complete-check");
    const wasChecked = curElem && curElem.classList.contains("checked");

    if (!wasChecked) {
      if (!curElem || !curInputElem || !spinAnim || !checkElem) return;
      if (spinAnim.style.display === "block" || curInputElem.checked) return;
      const form = document.querySelector("form.shipping-protection-form");

      const formData = new FormData(form);
      if (!formData.get("id")) {
        console.error(
          "There is no shipping protection product selected. Please select the shipping product in the global theme settings",
        );
        return;
      }

      spinAnim.style.display = "block";

      const markInsuranceOn = () => {
        const sw = document.querySelector(".gb-shipping-protection-button label.switch");
        const inp = sw && sw.querySelector("input");
        if (sw) {
          sw.classList.remove("unchecked");
          sw.classList.add("checked");
          sw.setAttribute("aria-checked", "true");
        }
        if (inp) inp.checked = true;
        if (checkElem) checkElem.style.display = "block";
        if (spinAnim) spinAnim.style.display = "none";
      };

      try {
        const variantId = formData.get("id");
        const response = await fetch(routes.cart_add_url, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: 1 }],
            sections: "cart-drawer,cart-icon-bubble",
            sections_url: window.location.pathname,
          }),
        });

        if (!response.ok) {
          spinAnim.style.display = "none";
          console.error("shipping protection add failed", response.status);
          return;
        }

        const data = await response.json();
        if (typeof window.tlApplyCartDrawerSections === "function") {
          window.tlApplyCartDrawerSections(data, markInsuranceOn);
        } else {
          markInsuranceOn();
          await window.tlRefreshCartDrawerSections(markInsuranceOn);
        }
      } catch (err) {
        console.error("error at shipping protection form submission", err);
        if (spinAnim) spinAnim.style.display = "none";
      }
    } else {
      if (checkElem) checkElem.style.display = "none";
      const cartDrawer = document.querySelector("#CartDrawer");
      const spId = window.shippingProductId || shippingProductId;
      const removeButton = cartDrawer.querySelector(`cart-remove-button[data-id="${spId}"]`);
      const shippingItemIndex = removeButton?.dataset.index;

      const removeCallback = () => {
        const sw = document.querySelector(".gb-shipping-protection-button label.switch");
        const inp = sw && sw.querySelector("input");
        if (sw) {
          sw.classList.remove("checked");
          sw.classList.add("unchecked");
          sw.setAttribute("aria-checked", "false");
        }
        if (inp) inp.checked = false;
      };

      const cartItems = cartDrawer.querySelector("cart-items") || cartDrawer.querySelector("cart-drawer-items");

      if (removeButton && shippingItemIndex && cartItems?.updateQuantity) {
        const event = new CustomEvent("remove-shipping-protection", {
          detail: null,
        });
        cartItems.updateQuantity(shippingItemIndex, 0, event, "", "", removeCallback);
      } else {
        fetch(routes.cart_change_url, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            id: spId,
            quantity: 0,
            sections: "cart-drawer,cart-icon-bubble",
            sections_url: window.location.pathname,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            if (typeof window.tlApplyCartDrawerSections === "function") {
              window.tlApplyCartDrawerSections(data, removeCallback);
            } else if (typeof window.tlRefreshCartDrawerSections === "function") {
              return window.tlRefreshCartDrawerSections(removeCallback);
            } else {
              removeCallback();
            }
          })
          .catch(() => {
            removeCallback();
          });
      }
    }
  });

  document.body.addEventListener("change", function (e) {
    var select = e.target.closest && e.target.closest(".gb-change-variant_id");
    if (!select) return;
    var opt = select.options[select.selectedIndex];
    var id_change = opt ? opt.getAttribute("data-variant-id") : null;
    if (!id_change) {
      console.error("No data-variant-id found on selected option");
      return;
    }
    var block = select.closest(".gb-get-main-freq-pro");
    var input = block ? block.querySelector(".product-variant-id") : null;
    if (input) input.value = id_change;
  });
});

document.addEventListener("change", function (e) {
  if (e.target.matches(".cart-drawer .gbfrequently-bought-with-main-whole .select__select")) {
    const parentBlock = e.target.closest(".gb-get-main-freq-pro");
    if (!parentBlock) {
      console.log("Error: Could not find parent block");
      return;
    }

    const allValues = Array.from(parentBlock.querySelectorAll(".select__select"))
      .map((sel) => sel.value)
      .join(" / ");

    const variantSelect = parentBlock.querySelector('[name="variants"]');
    if (!variantSelect) {
      console.log("Error: Could not find variant selector");
      return;
    }

    const matchedOption = Array.from(variantSelect.options).find((option) => option.text.includes(allValues));

    const idInput = parentBlock.querySelector('[name="id"]');
    if (!idInput) {
      console.log("Error: Could not find id input field");
      return;
    }

    if (matchedOption) {
      console.log("Matched variant option value:", matchedOption.value);
      idInput.value = matchedOption.value;
      console.log("Set ID input value to:", idInput.value);
    } else {
      console.log("No matching variant found for:", allValues);
    }
  }
});

// Add validation for form submissions: require id when in single-variant mode; skip when form has items[] (bundles / premium kit)
document.addEventListener("submit", function (e) {
  if (typeof Elixir_ProductFormExists !== 'function' || !Elixir_ProductFormExists()) return;
  if (typeof Elixir_GetProductForm !== 'function' || Elixir_GetProductForm() !== e.target) return;
  if (typeof Elixir_GetProductFormVariantId !== 'function') return;
  if (typeof Elixir_ProductFormHasItemsInputs === 'function' && Elixir_ProductFormHasItemsInputs()) return;
  const variantId = Elixir_GetProductFormVariantId();
  if (!variantId) {
    console.log("Preventing submission - missing id parameter (single-product form has no variant id)");
    e.preventDefault();
    if (window.ThemeEditorToast && typeof window.ThemeEditorToast.show === 'function') {
      window.ThemeEditorToast.show('Add to cart failed: missing variant ID on product form.', { type: 'error', duration: 5000 });
    }
    return false;
  }
});

document.addEventListener("DOMContentLoaded", function () {
  function handleCartQuantityChange(e) {
    var cartItem = e.target.closest(".cart-item");
    if (!cartItem) return;
    var trigger =
      e.target.closest(".quantity__button") ||
      e.target.closest(".quantity__input") ||
      (e.target.matches && e.target.matches(".quantity__input") ? e.target : null);
    if (!trigger) return;
    var quantityInputWrap = trigger.closest(".quantity-input");
    var qtyInput = quantityInputWrap ? quantityInputWrap.querySelector(".quantity__input") : null;
    var variantId = qtyInput ? qtyInput.getAttribute("data-quantity-variant-id") : null;
    var form = trigger.closest("form");
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput && variantId) {
      console.log("Adding missing ID input to cart form");
      var newIdInput = document.createElement("input");
      newIdInput.type = "hidden";
      newIdInput.name = "id";
      newIdInput.value = variantId;
      form.appendChild(newIdInput);
    } else if (idInput && variantId) {
      idInput.value = variantId;
    }
  }
  document.addEventListener("click", handleCartQuantityChange);
  document.addEventListener("change", handleCartQuantityChange);
  document.addEventListener("input", handleCartQuantityChange);

  /**
   * NUCLEAR checkout: previous handler called preventDefault when
   * form.querySelectorAll('.cart-item').length === 0. After shipping-insurance
   * AJAX redraws, that selector can falsely be 0 while totals still show money —
   * which killed <a href="/checkout"> navigation. Force assign instead.
   */
  /**
   * Always navigate on checkout CTA click. Native <a> navigation can be
   * swallowed when Shopify's privacy banner (or another overlay) sits on top
   * and steals the gesture — force assign so a real hit still checks out.
   */
  function tlGoCheckout(e) {
    var el =
      e.target &&
      e.target.closest &&
      e.target.closest(
        "#CartDrawer-Checkout, #checkout, a.tl-cart-sticky, a.tl-cart-sticky__btn, a[data-tl-cart-checkout], button[data-tl-cart-checkout]"
      );
    if (!el) return;
    if (el.disabled || el.getAttribute("aria-disabled") === "true") return;
    /* Always use geo-aware checkout — BE must get Bancontact, not iDEAL */
    e.preventDefault();
    e.stopPropagation();
    if (typeof window.tlAssignCheckout === "function") {
      window.tlAssignCheckout();
      return;
    }
    window.location.assign(window.tlCheckoutHref());
  }
  document.addEventListener("click", tlGoCheckout, true);

  function tlSyncPrivacyBannerForCart() {
    try {
      var open = !!document.querySelector("cart-drawer.active, cart-drawer[open]");
      document.documentElement.classList.toggle("tl-cart-drawer-open", open);
      var banner = document.getElementById("shopify-pc__banner");
      if (!banner) return;
      if (open || document.body.classList.contains("template-cart")) {
        banner.setAttribute("data-tl-cart-hidden", "1");
        banner.style.setProperty("pointer-events", "none", "important");
        banner.style.setProperty("visibility", "hidden", "important");
        banner.style.setProperty("opacity", "0", "important");
      } else if (banner.getAttribute("data-tl-cart-hidden") === "1") {
        banner.removeAttribute("data-tl-cart-hidden");
        banner.style.removeProperty("pointer-events");
        banner.style.removeProperty("visibility");
        banner.style.removeProperty("opacity");
      }
    } catch (err) {}
  }

  function tlEnsureCheckoutLinks() {
    var checkoutHref = window.tlCheckoutHref();
    ["#CartDrawer-Checkout", "#checkout", "a.tl-cart-sticky", "a.tl-cart-sticky__btn", "a[data-tl-cart-checkout]"].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.tagName === "BUTTON" && !el.disabled && el.id) {
          var a = document.createElement("a");
          a.href = checkoutHref;
          a.id = el.id;
          a.className = el.className;
          a.setAttribute("data-tl-cart-checkout", "");
          a.setAttribute("role", "link");
          a.innerHTML = el.innerHTML;
          a.style.cssText = "pointer-events:auto !important;position:relative;z-index:2147483646;";
          el.replaceWith(a);
          el = a;
        }
        if (el.tagName === "A") {
          el.setAttribute("href", checkoutHref);
          el.setAttribute("data-tl-cart-checkout", "");
          el.removeAttribute("disabled");
          el.setAttribute("aria-disabled", "false");
          el.style.pointerEvents = "auto";
          el.style.position = "relative";
          el.style.zIndex = "2147483646";
        }
      });
    });
    tlSyncPrivacyBannerForCart();
  }
  tlEnsureCheckoutLinks();
  tlSyncPrivacyBannerForCart();
  document.addEventListener("cart-drawer:update", tlEnsureCheckoutLinks);
  document.addEventListener("cart:updated", tlEnsureCheckoutLinks);
  document.addEventListener("cart:refresh", tlEnsureCheckoutLinks);
  document.documentElement.addEventListener("cart:refresh", tlEnsureCheckoutLinks);
  document.addEventListener("shopify:section:load", tlSyncPrivacyBannerForCart);
  var _tlCartDrawerEl = document.querySelector("cart-drawer");
  if (_tlCartDrawerEl && typeof MutationObserver !== "undefined") {
    new MutationObserver(tlSyncPrivacyBannerForCart).observe(_tlCartDrawerEl, {
      attributes: true,
      attributeFilter: ["class", "open"],
    });
  }

  document.addEventListener("keydown", function (e) {
    var input =
      (e.target.matches && e.target.matches(".quantity__input")
        ? e.target
        : e.target.closest && e.target.closest(".quantity__input")) || null;
    if (!input) return;
    if (e.key === "Enter" || e.keyCode === 13) {
      e.preventDefault();
      input.blur();
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (e) {
    var btn =
      e.target.closest(".gbfrequently-bought-with-main-whole button") ||
      e.target.closest(".gbfrequently-bought-with-main-whole .gb-sumbit-free") ||
      e.target.closest(".gb-free-product-trigger") ||
      e.target.closest(".gb-product-shipping-protection-product-tirgger") ||
      e.target.closest(".gb-product-sticky-add-to-cart-form");
    if (!btn) return;
    var parentBlock = btn.closest(".gb-get-main-freq-pro") || btn.closest("form");
    if (!parentBlock) {
      console.error("Could not find parent block for frequently bought product");
      return;
    }
    var productId = null;
    var idInput = parentBlock.querySelector('input[name="id"]');
    if (idInput && idInput.value) {
      productId = idInput.value;
    } else if (parentBlock.querySelector(".gb-change-variant_id")) {
      var select = parentBlock.querySelector(".gb-change-variant_id");
      var opt = select && select.options[select.selectedIndex];
      if (opt) {
        productId = opt.getAttribute("data-variant-id");
      }
    } else if (parentBlock.querySelector(".product-variant-id")) {
      var variantInput = parentBlock.querySelector(".product-variant-id");
      productId = variantInput ? variantInput.value : null;
    } else if (btn.getAttribute("data-variant-id")) {
      productId = btn.getAttribute("data-variant-id");
    }
    console.log("Frequently bought product add to cart - ID:", productId);
    if (btn.classList.contains("gb-free-product-trigger") && !show_progress_bar) return;
    if (!productId) {
      console.error("Missing product ID for frequently bought product");
      e.preventDefault();
      return false;
    }
    if (!idInput) {
      console.log("Adding missing ID input to frequently bought product form");
      var newIdInput = document.createElement("input");
      newIdInput.type = "hidden";
      newIdInput.name = "id";
      newIdInput.value = productId;
      parentBlock.appendChild(newIdInput);
    } else {
      idInput.value = productId;
    }
    var quantityInput = parentBlock.querySelector('input[name="quantity"]');
    if (!quantityInput) {
      console.log("Adding default quantity input to frequently bought product form");
      var newQtyInput = document.createElement("input");
      newQtyInput.type = "hidden";
      newQtyInput.name = "quantity";
      newQtyInput.value = "1";
      parentBlock.appendChild(newQtyInput);
    } else if (!quantityInput.value || parseFloat(quantityInput.value, 10) < 1) {
      quantityInput.value = "1";
    }
  });
});

// Kaching showing Price(Compare Price) Text in ATC fix

const KachingApp = () => {
  var _tlKachingPath = (location.pathname || '').toLowerCase();
  if (/\/products\/(sauteerpan|twee-handgrepen|wok-vlakke-bodem|hoge-rand|diepe-pan|crepepan|kookpan)(?:\/|$)/.test(_tlKachingPath)) return;
  if (/\/products\/[^/]*(ice-cube|straw|utensil)/.test(_tlKachingPath) || document.getElementById('tl-buybox-mock')) return;
  const isProductPage = document.querySelector('.shopify-section.shop-product-section');
  if (!isProductPage) return;

  let buttonObserver = null;

  const createElement = (tag, cls, content) => {
    const el = document.createElement(tag);
    el.classList.add(...cls.split(' '));
    el.textContent = content;
    return el;
  };

  const updateAddToCartButton = (bundle) => {
    const addToCartButton = document.querySelector('.shop-add-to-cart-button');
    if (!addToCartButton || !bundle) return;

    const buttonTextEl = addToCartButton.querySelector('.button-text');
    if (!buttonTextEl) return;

    const bundlePriceEl = bundle.querySelector('.kaching-bundles__bar-price');
    const bundleComparePriceEl = bundle.querySelector('.kaching-bundles__bar-full-price');

    if (bundlePriceEl) {
      const price = bundlePriceEl.textContent.trim();
      const comparePrice = bundleComparePriceEl ? bundleComparePriceEl.textContent.trim() : '';

      // Get the persistent text (e.g., "Buy Now")
      const persistentText = addToCartButton.getAttribute('data-persistent-text') || 'Buy Now';

      // Update button text with actual values
      if (comparePrice) {
        buttonTextEl.innerHTML = `${persistentText} - ${price}<span class="compare-price">(${comparePrice})</span>`;
      } else {
        buttonTextEl.innerHTML = `${persistentText} - ${price}`;
      }

      // Store current bundle reference for observer
      addToCartButton.dataset.currentBundlePrice = price;
      addToCartButton.dataset.currentBundleComparePrice = comparePrice || '';
    }
  };

  const forceUpdateButton = () => {
    const addToCartButton = document.querySelector('.shop-add-to-cart-button');
    const buttonTextEl = addToCartButton?.querySelector('.button-text');
    
    if (!buttonTextEl) return;

    const price = addToCartButton.dataset.currentBundlePrice;
    const comparePrice = addToCartButton.dataset.currentBundleComparePrice;
    const persistentText = addToCartButton.getAttribute('data-persistent-text') || 'Buy Now';

    // Check if button shows placeholders
    if (buttonTextEl.textContent.includes('[price]') || buttonTextEl.textContent.includes('[comparePrice]')) {
      if (price) {
        if (comparePrice) {
          buttonTextEl.innerHTML = `${persistentText} - ${price}<span class="compare-price">(${comparePrice})</span>`;
        } else {
          buttonTextEl.innerHTML = `${persistentText} - ${price}`;
        }
      }
    }
  };

  const setupButtonObserver = () => {
    const addToCartButton = document.querySelector('.shop-add-to-cart-button');
    if (!addToCartButton) return;

    // Disconnect existing observer if any
    if (buttonObserver) {
      buttonObserver.disconnect();
    }

    // Create new observer to watch for button text changes
    buttonObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          // Use setTimeout to let the other script finish, then override
          setTimeout(forceUpdateButton, 0);
        }
      });
    });

    // Observe the button and its children for any changes
    buttonObserver.observe(addToCartButton, {
      childList: true,
      subtree: true,
      characterData: true,
      characterDataOldValue: true
    });
  };

  const updatePriceBlock = (bundle) => {
    const priceBlock = document.querySelector('.shop-product-price-container');
    if (!priceBlock || !bundle) return;

    const priceEl = priceBlock.querySelector('.shop-product-price-block');
    const comparePriceEl = priceBlock.querySelector('.shop-compare-price');

    const bundlePriceEl = bundle.querySelector('.kaching-bundles__bar-price');
    const bundleComparePriceEl = bundle.querySelector('.kaching-bundles__bar-full-price');

    if (priceEl && bundlePriceEl) priceEl.textContent = bundlePriceEl.textContent;

    if (bundleComparePriceEl) {
      if (comparePriceEl) {
        comparePriceEl.textContent = bundleComparePriceEl.textContent;
      } else {
        priceBlock.appendChild(
          createElement('span', 'shop-compare-price', bundleComparePriceEl.textContent)
        );
      }
    }
  };

  const updateAllPrices = (bundle) => {
    updatePriceBlock(bundle);
    updateAddToCartButton(bundle);
    
    // Force update again after a short delay to override any competing scripts
    setTimeout(() => forceUpdateButton(), 50);
    setTimeout(() => forceUpdateButton(), 200);
  };

  const initApp = (app) => {
    const applyFirstCheckedBundle = () => {
      const selectedBundle = app.querySelector('.kaching-bundles__bar:has(input:checked)');
      if (selectedBundle) {
        updateAllPrices(selectedBundle);
      }
    };

    const initAppFunctions = () => {
      const interval = setInterval(() => {
        const selectedBundle = app.querySelector('.kaching-bundles__bar:has(input:checked)');
        if (selectedBundle) {
          clearInterval(interval);
          updateAllPrices(selectedBundle);
          setupButtonObserver();
        }
      }, 300);
    };

    app.addEventListener('change', () => {
      const selectedBundle = app.querySelector('.kaching-bundles__bar:has(input:checked)');
      updateAllPrices(selectedBundle);
    });

    applyFirstCheckedBundle();
    initAppFunctions();
  };

  const interval = setInterval(() => {
    const app = document.querySelector('kaching-bundle');
    if (app) {
      clearInterval(interval);
      initApp(app);
    }
  }, 300);
  // Never poll forever on pan PDPs without Kaching
  setTimeout(function () { clearInterval(interval); }, 8000);
};

window.addEventListener('DOMContentLoaded', KachingApp);
;/* tl-hide-tgem-trust-hook */(function(){try{if(document.getElementById("tl-hide-tgem-trust"))return;var s=document.createElement("style");s.id="tl-hide-tgem-trust";s.textContent=".tgem-trust,p.tgem-trust{display:none!important}";(document.head||document.documentElement).appendChild(s);document.querySelectorAll("p.tgem-trust,.tgem-trust").forEach(function(el){el.style.setProperty("display","none","important")});}catch(e){}})();


/* tl-hero-video-behind: loaded from layout/theme.liquid via asset_url on Chef's Pan pages */


/* tl-dedupe-summer-bar-20260820-nl-offer-pin */
(function () {
  try {
    var _toolPath = (location.pathname || '').toLowerCase();
    if (/\/products\/(sauteerpan|twee-handgrepen|wok-vlakke-bodem|hoge-rand|diepe-pan|crepepan|kookpan)(?:\/|$)/.test(_toolPath)) return;
    if (/\/products\/[^/]*(ice-cube|straw|utensil)/.test(_toolPath)) return;
    function isNl() {
      var p = (location.pathname || '').toLowerCase();
      return p === '/nl' || p.indexOf('/nl/') === 0;
    }
    function saleLabel() {
      if (document.querySelector('[data-tl-stack-lp]')) {
        return isNl()
          ? 'Chef’s Pan 3-set €189,50 · Gratis verzending NL & BE'
          : 'Chef’s Pan 3-set €189,50 · Free shipping NL & BE';
      }
      return isNl()
        ? '2 artikelen 5% · 3 artikelen 10% · 4+ artikelen 15%'
        : '2 items 5% · 3 items 10% · 4+ items 15%';
    }
    var LABEL = saleLabel();
    function pinOfferBarNl() {
      var bar = document.querySelector('.titanore-offer-bar');
      if (!bar) return;
      var nl = isNl();
      bar.setAttribute('aria-label', nl ? 'Huidige aanbieding' : 'Current offer');
      var map = [
        document.querySelector('[data-tl-stack-lp]')
          ? ['.tob-sale', 'Chef’s Pan 3-set €189,50 · Free shipping NL & BE', 'Chef’s Pan 3-set €189,50 · Gratis verzending NL & BE']
          : ['.tob-sale', '2 items 5% · 3 items 10% · 4+ items 15%', '2 artikelen 5% · 3 artikelen 10% · 4+ artikelen 15%'],
        ['[data-en="PFAS-free"]', 'PFAS-free', 'PFAS-vrij'],
        ['.tob-trust, [data-en="Free shipping NL & BE · 30-day home trial · 25-year warranty"]', 'Free shipping NL & BE · 30-day home trial · 25-year warranty', 'Gratis verzending NL & BE · 30 dagen thuisproef · 25 jaar garantie']
      ];
      map.forEach(function (row) {
        bar.querySelectorAll(row[0]).forEach(function (el) {
          el.setAttribute('data-en', row[1]);
          el.setAttribute('data-nl', row[2]);
          el.setAttribute('data-wg-notranslate', '');
          el.setAttribute('translate', 'no');
          var want = nl ? row[2] : row[1];
          if ((el.textContent || '').replace(/\s+/g, ' ').trim() !== want) el.textContent = want;
        });
      });
      // Fallback: plain spans without data-en (older cached markup)
      if (nl) {
        bar.querySelectorAll('.tob-inner > span:not(.tob-sep):not(.tob-sale)').forEach(function (el) {
          var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
          if (/^PFAS-free$/i.test(t)) el.textContent = 'PFAS-vrij';
          else if (/free (eu )?shipping/i.test(t) || /gratis verzending/i.test(t) || /gratis retour/i.test(t) || /30-day/i.test(t)) {
            el.textContent = 'Gratis verzending NL & BE · 30 dagen thuisproef · 25 jaar garantie';
          }
        });
      }
    }
    function killDupes() {
      var official = document.querySelector('.titanore-offer-bar');
      document.querySelectorAll('#okhSummerStrip, #tlSummerStripLive').forEach(function (el) { el.remove(); });
      document.querySelectorAll('.section-titanore-top-offer, .titanore-top-offer').forEach(function (el) {
        var sec = el.classList.contains('shopify-section') ? el : el.closest('.shopify-section');
        if (sec) sec.style.display = 'none';
        else el.style.display = 'none';
      });
      // If multiple offer bars, keep first only
      var seen = 0;
      document.querySelectorAll('.shopify-section.section-titanore-offer-bar').forEach(function (sec) {
        seen += 1;
        if (seen > 1) sec.style.display = 'none';
      });
      // Fix "% 40%" / SAVE 40% inside the remaining bar — keep NL on /nl
      var sale = document.querySelector('.titanore-offer-bar .tob-sale');
      if (sale) {
        sale.querySelectorAll('.tob-mark').forEach(function (m) { m.remove(); });
        sale.setAttribute('data-wg-notranslate', '');
        sale.setAttribute('translate', 'no');
        sale.setAttribute('data-en', '2 items 5% · 3 items 10% · 4+ items 15%');
        sale.setAttribute('data-nl', '2 artikelen 5% · 3 artikelen 10% · 4+ artikelen 15%');
        sale.textContent = LABEL;
      }
      pinOfferBarNl();
      var inner = document.querySelector('.titanore-offer-bar .tob-inner');
      if (inner) {
        // rebuild clean single line if messy
        var parts = Array.prototype.map.call(inner.querySelectorAll(':scope > span:not(.tob-sep)'), function (s) {
          return (s.textContent || '').replace(/\s+/g, ' ').trim();
        }).filter(Boolean);
        // ensure first is summer label
        if (parts.length) {
          // no-op structural; text already fixed on .tob-sale
        }
      }
    }
    function stickyChip() {
      if (document.querySelector('[data-tl-stack-lp]')) return;
      var price = document.querySelector('#tgem-shop-sticky .price');
      if (!price) return;
      var save = price.querySelector('[data-ss-save], .tl-ss-save');
      var chip = price.querySelector('.tl-summer-chip, [data-ss-chip]');
      /* Calculated % + euro save already lives in .tl-ss-save — don't duplicate a campaign chip. */
      if (save && (save.textContent || '').trim()) {
        if (chip) chip.remove();
        return;
      }
      if (!chip) {
        chip = document.createElement('span');
        chip.className = 'tl-summer-chip';
        chip.setAttribute('data-ss-chip', '');
        price.appendChild(chip);
      }
      var en = '40% SUMMER DISCOUNT';
      var nl = '40% zomerkorting';
      chip.setAttribute('data-en', en);
      chip.setAttribute('data-nl', nl);
      chip.setAttribute('data-wg-notranslate', '');
      chip.setAttribute('translate', 'no');
      if (chip.textContent !== (isNl() ? nl : en)) chip.textContent = isNl() ? nl : en;
    }
    function cookieBannerBlocksSticky() {
      if (document.documentElement.classList.contains('tl-privacy-banner-open')) return true;
      if (typeof window.__tlCookieBannerOpen === 'function' && window.__tlCookieBannerOpen()) return true;
      var b = document.getElementById('shopify-pc__banner');
      var p = document.getElementById('shopify-pc__prefs');
      return [b, p].some(function (el) {
        if (!el || el.getAttribute('data-tl-cart-hidden') === '1') return false;
        var s = window.getComputedStyle(el);
        if (s.display === 'none' || s.visibility === 'hidden') return false;
        var r = el.getBoundingClientRect();
        return r.width > 0 && r.height > 0;
      });
    }
    function pinStickyBar() {
      if (cookieBannerBlocksSticky()) return;
      var p = (location.pathname || '').toLowerCase();
      if (/\/products\//.test(p) && !/hammered-pan|chefs-pan-set|cutting-board|benefit-pan|benefit-board/.test(p)) {
        var wrongBar = document.getElementById('tgem-shop-sticky');
        if (wrongBar) wrongBar.remove();
        var hideStyle = document.getElementById('tgem-hide-theme-sticky');
        if (hideStyle) hideStyle.remove();
        document.body.classList.remove('tgem-shop-sticky-pad');
        return;
      }
      var bar = document.getElementById('tgem-shop-sticky');
      if (!bar) return;
      if (bar.parentNode !== document.body) document.body.appendChild(bar);
      /* Thommy 02-09: visibility is 60% scroll in titanore-sitewide-atc.js. Do not force is-on. */
    }
    function stripStickyCtaPrice() {
      var nl = isNl();
      var label = nl ? 'In winkelwagen' : 'Add to cart';
      var setLabel = nl ? 'Set in winkelwagen' : 'Add set to cart';
      document.querySelectorAll(
        '#stickyAddToCart .button-text, #tgem-shop-sticky [data-ss-cta], .tgem-sticky__cta, [data-tgem-sticky-cta], [data-tcpb-sticky-cta], .sticky-add-to-cart__button .button-text'
      ).forEach(function (el) {
        var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!t || !(/[€£$]/.test(t) || /\s[—–-]\s/.test(t))) return;
        var next = t
          .replace(/\s*[—–-]\s*€[\d.,]+.*$/i, '')
          .replace(/\s*-\s*€[\d.,]+.*$/i, '')
          .replace(/\s*\(€[\d.,]+.*?\)/g, '')
          .trim();
        if (!next) next = /set/i.test(t) ? setLabel : label;
        if (next !== t) {
          el.setAttribute('data-wg-notranslate', '');
          el.setAttribute('translate', 'no');
          el.textContent = next;
        }
      });
    }
    function productKind() {
      var p = (location.pathname || '').toLowerCase();
      if (/cutting-board|snijplank/.test(p)) return 'board';
      if (/straw|ice-cube|utensil|accessor/.test(p)) return 'tool';
      if (/chefs-pan-set|pan-set/.test(p)) return 'panset';
      if (/hammered-pan|chefs-pan|titanium-pan/.test(p)) return 'pan';
      return 'generic';
    }
    function packPair(kind, n) {
      if (kind === 'board') {
        if (n === 1) return { en: 'One board', nl: 'Eén plank' };
        if (n === 2) return { en: 'Set of two', nl: 'Set van twee' };
        if (n === 3) return { en: 'Set of three', nl: 'Set van drie' };
        if (n === 4) return { en: 'Set of four', nl: 'Set van vier' };
        if (n === 6) return { en: 'Set of six', nl: 'Set van zes' };
      }
      if (kind === 'tool') {
        if (n === 1) return { en: 'One set', nl: 'Eén set' };
        if (n === 2) return { en: 'Set of two', nl: 'Set van twee' };
        if (n === 3) return { en: 'Set of three', nl: 'Set van drie' };
        if (n === 4) return { en: 'Set of four', nl: 'Set van vier' };
        if (n === 6) return { en: 'Set of six', nl: 'Set van zes' };
      }
      if (n === 1) return { en: 'One pan', nl: 'Eén pan' };
      if (n === 2) return { en: 'Set of two', nl: 'Set van twee' };
      if (n === 3) return { en: 'Set of three', nl: 'Set van drie' };
      if (n === 4) return { en: 'Set of four', nl: 'Set van vier' };
      if (n === 6) return { en: 'Set of six', nl: 'Set van zes' };
      return null;
    }
    function matchPack(text) {
      var t = (text || '').replace(/\s+/g, ' ').trim();
      if (!t) return null;
      if (/^(small|medium|large|groot|standard|milkshake|default title)$/i.test(t)) return null;
      if (/\d+\s*cm/i.test(t) && !/pack|set|pcs|stuks/i.test(t)) return null;
      var m = t.match(/^(?:single(?:\s+pan|\s+board|\s+set)?|one(?:\s+pan|\s+board|\s+set)?|losse\s+(?:pan|plank)|één\s+(?:pan|plank|set|stuks)|een\s+(?:pan|plank|set|stuks))$/i);
      if (m) return 1;
      m = t.match(/^(?:pack of (?:two|2)|set of (?:two|2)|set van (?:twee|2)|twee pannen|2[\s-]?pan)$/i);
      if (m) return 2;
      m = t.match(/^(?:pack of (?:three|3)|set of (?:three|3)|set van (?:drie|3)|drie pannen|3[\s-]?pan)$/i);
      if (m) return 3;
      m = t.match(/^(?:4\s*pcs|4pcs|pack of (?:four|4)|set of (?:four|4)|set van (?:vier|4)|4\s*stuks)$/i);
      if (m) return 4;
      m = t.match(/^(?:6\s*pcs|6pcs|pack of (?:six|6)|set of (?:six|6)|set van (?:zes|6)|6\s*stuks)$/i);
      if (m) return 6;
      return null;
    }
    function applyLabel(el, pair) {
      if (!el || !pair) return;
      el.setAttribute('data-en', pair.en);
      el.setAttribute('data-nl', pair.nl);
      el.setAttribute('data-wg-notranslate', '');
      el.setAttribute('translate', 'no');
      if (el.tagName === 'INPUT' || el.tagName === 'OPTION') {
        if (el.tagName === 'OPTION') el.textContent = isNl() ? pair.nl : pair.en;
        return;
      }
      if (el.childNodes.length === 1 && el.childNodes[0].nodeType === 3) {
        el.textContent = isNl() ? pair.nl : pair.en;
        return;
      }
      var textNode = null;
      el.childNodes.forEach(function (n) {
        if (n.nodeType === 3 && n.nodeValue && n.nodeValue.trim()) textNode = n;
      });
      if (textNode) textNode.nodeValue = isNl() ? pair.nl : pair.en;
      else if (!el.children.length) el.textContent = isNl() ? pair.nl : pair.en;
    }
    function fixPackNames() {
      var kind = productKind();
      var nodes = document.querySelectorAll(
        '.tl-pack-name, [data-option-value], .kaching-bundles__bar, .kaching-bundles__bar-title, .product-form__input label, .variant-input label, .swatch-input__label, option, .okh-bun-label, [data-value]'
      );
      nodes.forEach(function (el) {
        var sample = (el.getAttribute('data-option-value') || el.getAttribute('data-value') || el.getAttribute('data-en') || el.textContent || '').trim();
        var n = matchPack(sample);
        if (n == null) return;
        applyLabel(el, packPair(kind, n));
      });
      document.querySelectorAll('.tl-size-line, [data-en*="One board"], [data-nl*="board"]').forEach(function (el) {
        var en = el.getAttribute('data-en') || '';
        if (/one board/i.test(en) || /één board|een board/i.test(el.getAttribute('data-nl') || '') || /one board/i.test(el.textContent || '')) {
          el.setAttribute('data-en', en.replace(/One board/i, 'One board'));
          el.setAttribute('data-nl', (el.getAttribute('data-nl') || '').replace(/Één board|Een board|Eén board/i, 'Eén plank'));
          if (isNl()) el.textContent = (el.textContent || '').replace(/One board|Één board|Een board|Eén board/ig, 'Eén plank');
        }
      });
    }
    function rewriteSaleEnglish() {
      if (!isNl()) return;
      if (document.querySelector('[data-tl-stack-lp]')) return;
      document.querySelectorAll('.tsc-badge, .tsc-sub, .tss-save, .tl-price-off, .tl-summer-chip, .okcat-badge, .okh-mob-sale, .okh-mega-feature__tag, [data-ss-chip], [data-tl-sale]').forEach(function (el) {
        var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!t) return;
        /* Computed % vs original list — do not flatten 60%/66% to 40%. */
        if (el.matches('.tss-save, .tgem-size__pct, .tl-option-pct, .tl-format__pct, .ck-save, .tcpb-set__disc')) return;
        if (/^−?\d+%$/.test(t) || /%\s*(OFF|korting)\s*$/i.test(t)) return;
        if (!/SUMMER DISCOUNT|60%\s|70%\s/i.test(t) && !/^[0-9]+%\s*ZOMERKORTING$/i.test(t) && !/^[0-9]+%\s*zomerkorting$/i.test(t)) return;
        el.setAttribute('data-wg-notranslate', '');
        el.setAttribute('translate', 'no');
        var next = t
          .replace(/70%\s*/ig, '40% ')
          .replace(/60%\s*/ig, '40% ')
          .replace(/SUMMER DISCOUNT/ig, 'zomerkorting')
          .replace(/ZOMERKORTING/g, 'zomerkorting');
        var isBadge = el.matches('.tsc-badge, .tss-save, .tl-price-off, .tl-summer-chip, .okcat-badge, .okh-mob-sale, .okh-mega-feature__tag, [data-ss-chip], [data-tl-sale]');
        if (isBadge) next = '40% zomerkorting';
        if ((el.textContent || '').replace(/\s+/g, ' ').trim() === next) return;
        el.textContent = next;
        if (el.hasAttribute('data-en')) el.setAttribute('data-en', '40% SUMMER DISCOUNT');
        if (el.hasAttribute('data-nl')) el.setAttribute('data-nl', '40% zomerkorting');
      });
    }
    var TITLE_NL = {
      'chefs-pan-set-3-pans-titanium-utensils': "Chef's Pan-set: 3 pannen + titanium keukengerei",
      'titanium-cutting-board-shop': 'Titanium snijplank',
      'titanium-hammered-pan-pro-large': "Chef's Pan · Large",
      'titanium-hammered-pan-pro-medium': "Chef's Pan · Medium",
      'titanium-hammered-pan-pro-small': "Chef's Pan · Small",
      'chefs-pan-set-3': "Chef's Pan-set · 3 pannen",
      'chefs-pan-set-2': "Chef's Pan-set · 2 pannen",
      'titanium-straws': 'Titanium rietjes',
      'titanium-ice-cubes': 'Titanium ijsblokjes',
      'titanium-utensil-set-bundle': 'Titanium keukengerei-set',
      'titanium-cutting-board-bundle': 'Titanium snijplanken-set'
    };
    function handleFromHref(href) {
      var m = (href || '').match(/\/products\/([^/?#]+)/i);
      return m ? decodeURIComponent(m[1]).toLowerCase() : '';
    }
    var COL_NL = {
      'titanium-cutting-system': 'Titanium snijplanken',
      'titanium-cutting-board': 'Snijplanken',
      'cutting-boards': 'Snijplanken',
      'cutting-board': 'Snijplanken',
      'titanium-pan': 'Massief titanium pannen',
      'chefs-pan': "Chef's Pan",
      'pan-sets': 'Pannensets',
      'sets': 'Sets',
      'accessories': 'Accessoires',
      'kitchen-accessories': 'Keukenaccessoires',
      'kitchen-accessories-collection': 'Keukenaccessoires'
    };
    function pinMicrocopyMap() {
      /* king=57nlreadmore — buybox extra + Lees minder */
      if (!isNl()) return;
      var EXACT = {
        'Add to cart': 'In winkelwagen',
        'Add to Cart': 'In winkelwagen',
        'SHOP NOW': 'Shop nu',
        'Shop now': 'Shop nu',
        'Highest discount': 'Hoogste korting',
        'Complete order': 'Bestelling afronden',
        'Single pans': 'Losse pannen',
        'Single Pans': 'Losse pannen',
        'Add set to cart': 'Set in winkelwagen',
        'Add bundle to cart': 'Bundel in winkelwagen',
        'View': 'Bekijk',
        'Choose options': 'Kies opties',
        'Sold out': 'Uitverkocht',
        'Shop all products': 'Bekijk alle producten',
        'All products': 'Alle producten',
        'Frequently Asked Questions': 'Veelgestelde vragen',
        'Everything you want to know about our products.': 'Alles wat je wilt weten over onze producten.',
        'Stay Updated': 'Blijf op de hoogte',
        'Subscribe': 'Inschrijven',
        'Read more': 'Lees meer',
        'Read more...': 'Lees meer',
        'Read less': 'Lees minder',
        'Search...': 'Zoeken...',
        'Search pans, boards...': 'Pannen, planken zoeken...',
        'Your order': 'Je bestelling',
        'Complete order': 'Bestelling afronden',
        'Taxes included': 'Inclusief btw',
        'Why Titanium?': 'Waarom titanium?',
        'Shop sets': 'Bekijk sets',
        'Choose your size': 'Kies je maat',
        'Get It By': 'Bezorgd voor',
        'On the stove': 'Op het fornuis',
        'On the board': 'Op de plank',
        'Two pans. One solid titanium surface.': 'Twee pannen. Eén massief titanium kookoppervlak.',
        'Three pans. One solid titanium surface.': 'Drie pannen. Eén massief titanium kookoppervlak.',
        'Twee pannen. Eén massief titanium oppervlak.': 'Twee pannen. Eén massief titanium kookoppervlak.',
        'Drie pannen. Eén massief titanium oppervlak.': 'Drie pannen. Eén massief titanium kookoppervlak.',
        'Left the coating behind': 'De coating achter je gelaten',
        'Built for real prep': 'Gemaakt voor échte voorbereiding',
        'Technique': 'Techniek',
        'Construction': 'Constructie',
        'Why cooks leave coatings behind': 'Waarom koks coatings achterlaten',
        'How to get a clean release': 'Zo krijg je een schone loslating',
        "Titanium isn’t magic non-stick film - it performs best with correct heat and a little cooking fat.": 'Titanium is geen magische antiaanbakfolie — het werkt het best met de juiste hitte en een beetje vet.',
        "Titanium isn't magic non-stick film - it performs best with correct heat and a little cooking fat.": 'Titanium is geen magische antiaanbakfolie — het werkt het best met de juiste hitte en een beetje vet.',
        "Titanium isn’t magic non-stick film — it performs best with correct heat and a little cooking fat.": 'Titanium is geen magische antiaanbakfolie — het werkt het best met de juiste hitte en een beetje vet.',
        "Titanium isn't magic non-stick film — it performs best with correct heat and a little cooking fat.": 'Titanium is geen magische antiaanbakfolie — het werkt het best met de juiste hitte en een beetje vet.',
        'Preheat': 'Voorverwarmen',
        'Preheat on medium for 2–3 minutes. A drop of water should bead and glide across the surface.': 'Voorverwarm 2–3 minuten op middelhoog. Een druppel water moet parelen en over het oppervlak glijden.',
        'Preheat on medium for 2-3 minutes. A drop of water should bead and glide across the surface.': 'Voorverwarm 2–3 minuten op middelhoog. Een druppel water moet parelen en over het oppervlak glijden.',
        'Preheat on medium for 2-3 minutes. A drop of water should bead and glide.': 'Voorverwarm 2–3 minuten op middelhoog. Een druppel water moet parelen en over het oppervlak glijden.',
        'Add a little fat': 'Vet toevoegen',
        'Add a thin layer of oil or butter. It shimmers when the pan is ready for food.': 'Voeg een dunne laag olie of boter toe. Als het glanst, is de pan klaar voor het eten.',
        'Let it sear, then move': 'Eerst bakken, dan keren',
        "Food releases once a crust forms — don’t force the flip too early.": 'Het eten laat los als er een korstje is — forceer het keren niet te vroeg.',
        "Food releases once a crust forms — don't force the flip too early.": 'Het eten laat los als er een korstje is — forceer het keren niet te vroeg.',
        "Food releases once a crust forms - don’t force the flip too early.": 'Het eten laat los als er een korstje is — forceer het keren niet te vroeg.',
        "Food releases once a crust forms - don't force the flip too early.": 'Het eten laat los als er een korstje is — forceer het keren niet te vroeg.',
        "What's under the surface": 'Wat zit er onder het oppervlak',
        'A multi-layer build with a solid titanium cooking surface — no PFAS coating to scratch, peel, or wear away.': 'Een meerlaagse opbouw met een kookoppervlak van massief titanium — geen PFAS-coating die krast, bladder of wegslijt.',
        'A multi-layer build with a solid titanium cooking surface. No PFAS coating to scratch, peel, or wear away.': 'Een meerlaagse opbouw met een kookoppervlak van massief titanium — geen PFAS-coating die krast, bladder of wegslijt.',
        'Cooking surface · pure titanium': 'Kookoppervlak · puur titanium',
        'Hand-hammered microtexture — coating-free, metal-utensil safe, built to last.': 'Handgehamerde microtextuur — coatingvrij, veilig met metalen keukengerei, gemaakt om lang mee te gaan.',
        'Core · multi-layer heat': 'Kern · meerlaagse hitte',
        'Even heat across the base for honest searing — not a thin coated film.': 'Gelijkmatige hitte over de bodem voor eerlijk aanbakken — geen dunne coatingfilm.',
        'Base · induction ready': 'Bodem · inductiegeschikt',
        'Works on gas, induction, electric, ceramic, oven and grill — up to 540°C.': 'Werkt op gas, inductie, elektrisch, keramisch, oven en grill — tot 540°C.',
        'Premium rivets': 'Premium klinknagels',
        'Riveted handles stay anchored through years of stovetop and oven use on solid titanium.': 'Geklonken grepen blijven vast — jarenlang op het fornuis en in de oven, op massief titanium.',
        'Stay-cool handle': 'Koele greep',
        'Ergonomic grip shaped for everyday moves from sear to plate.': 'Ergonomische greep voor de beweging van aanbakken naar bord.',
        'Rolled rims': 'Omgerolde randen',
        'Cleaner pours with less drip down the outside of the pan.': 'Schonere schenk, minder druipen langs de buitenkant van de pan.',
        'Different kitchens. Same reason: no coating to baby.': 'Andere keukens. Dezelfde reden: geen coating om te ontzien.',
        'Weeknight cook': 'Doordeweekse kok',
        'I stopped babysitting heat and coating. Preheat, a little oil, and food lets go.': 'Ik stopte met hitte en coating in de gaten houden. Voorverwarmen, een beetje olie, en het eten laat los.',
        'Health-minded parent': 'Gezin, zonder PFAS',
        'I wanted PFAS-free without giving up a proper sear. Solid titanium solved both.': 'Ik wilde PFAS-vrij zonder in te leveren op echt aanbakken. Massief titanium doet beide.',
        'Former pro kitchen': 'Ex-profikeuken',
        "Heat distribution feels like pans I've used on the line — without a coating I'd replace yearly.": 'De hitteverdeling voelt als pannen van de pass — zonder een coating die je elk jaar vervangt.',
        'Heat distribution feels like pans I’ve used on the line — without a coating I’d replace yearly.': 'De hitteverdeling voelt als pannen van de pass — zonder een coating die je elk jaar vervangt.',
        'Verified buyer': 'Geverifieerde koper',
        'Verified customer · Former chef': 'Geverifieerde klant · Voormalig chef',
        "Chef’s Pan Set — 2 Pans": 'Chef’s Pan Set — 2 pannen',
        "Chef’s Pan Set — 3 Pans": 'Chef’s Pan Set — 3 pannen',
        'Finally a crust like a restaurant kitchen — at home, without a coating.': 'Eindelijk een korst zoals in de restaurantkeuken — thuis, zonder coating.',
        'I cook on real heat now. Vegetables stay crisp, nothing sticks.': 'Ik bak nu op échte hitte. Groenten blijven knapperig, niets plakt vast.',
        'Eggs in the morning, steak at night. Same pan, no coating to baby.': 'Ei in de ochtend, steak ’s avonds. Dezelfde pan, geen coating die ik spaar.',
        'Metal spatula, high heat, dishwasher. My old pans couldn’t do that.': 'Metalen spatel, hoge hitte, vaatwasser. Dat kon met mijn oude pannen niet.',
        'Preheat, a little butter, and pancakes slide right off.': 'Voorverwarmen, beetje boter, en pannenkoeken glijden eraf.',
        'Steak at home': 'Steak thuis',
        'Weeknight stir-fry': 'Weekavond wok',
        'Morning ritual': 'Ochtendritueel',
        'Family kitchen': 'Gezinskeuken',
        'Pancakes': 'Pannenkoeken',
        "Quotes from verified buyers and early customers. We don't invent review counts.": 'Citaten van geverifieerde kopers en vroege klanten. We verzinnen geen review-aantallen.',
        'Quotes from verified buyers and early customers. We don’t invent review counts.': 'Citaten van geverifieerde kopers en vroege klanten. We verzinnen geen review-aantallen.',
        'What makes Titanoré Labs pans different from ordinary non-stick pans?': 'Wat maakt Titanoré Labs-pannen anders dan gewone antiaanbakpannen?',
        'Are Titanoré Labs pans really safe to use?': 'Zijn Titanoré Labs-pannen vrij van chemische coating?',
        'Can I use metal kitchen utensils?': 'Kan ik metalen keukengerei gebruiken?',
        'Which heat sources can I use?': 'Welke warmtebronnen kan ik gebruiken?',
        'Is it dishwasher safe?': 'Is de pan vaatwasserbestendig?',
        'How do I care for my Titanoré Labs pan?': 'Hoe verzorg ik mijn Titanoré Labs-pan?',
        'How heavy are Titanoré Labs pans?': 'Hoe zwaar zijn Titanoré Labs-pannen?',
        'Do I need to season my Titanoré Labs pan?': 'Moet ik mijn Titanoré Labs-pan inbranden?',
        'Any questions?': 'Vragen?',
        'Contact us →': 'Neem contact op →',
        'Why coated pans keep disappointing': 'Waarom gecoate pannen teleurstellen',
        'Not All Pans Are Equal': 'Niet elke pan is gelijk',
        'How the cooking surface works': 'Zo werkt je pan',
        'Ready when you are': 'Klaar wanneer jij bent',
        'Kitchen notes': 'Keukentips',
        'Why people ditched coatings': 'Waarom mensen coatings lieten vallen',
        "Chef's Pan sets": "Chef's Pan-sets",
        'One set. Everyday cooking covered.': 'Eén set. Alledaags koken gedekt.',
        'Any questions? Contact us →': 'Vragen? Neem contact op →',
        'Newsletter': 'Nieuwsbrief',
        'Why solid titanium?': 'Waarom massief titanium?',
        'Materials & Construction': 'Materialen & constructie',
        'Size & Specifications': 'Maat & specificaties',
        'Cooking & Care': 'Koken & verzorging',
        'Shipping & Returns': 'Verzending & retour',
        'Solid titanium. No coating.': 'Massief titanium. Geen coating.',
        'Solid titanium · No PFAS / PTFE coating': 'Massief titanium · geen PFAS / PTFE-coating',
        'Massief titanium · Geen PFAS / PTFE-coating': 'Massief titanium · geen PFAS / PTFE-coating',
        'Small 26 cm + Medium 28 cm · Solid titanium · No PFAS / PTFE': 'Small 26 cm + Medium 28 cm · Massief titanium · geen PFAS / PTFE',
        'Small 26 cm + Medium 28 cm + Large 30 cm · Solid titanium · No PFAS / PTFE': 'Small 26 cm + Medium 28 cm + Large 30 cm · Massief titanium · geen PFAS / PTFE',
        'Built for high heat and everyday use, without PFAS, PFOA or PTFE coating.': 'Gemaakt voor hoge hitte en dagelijks gebruik, zonder PFAS-, PFOA- of PTFE-coating.',
        'This is not coated non-stick cookware. For best results, preheat gradually, use the right amount of cooking fat and let food release naturally before turning.': 'Dit is geen gecoate antiaanbakpan. Voor het beste resultaat: voorverwarm geleidelijk, gebruik voldoende kookvet en laat het eten loskomen voordat je keert.',
        'Coatings scratch, peel, and die. This pan has a solid titanium cooking surface — nothing to wear off.': 'Coatings krassen, bladderen en slijten. Dit kookoppervlak is massief titanium — er slijt niets af.',
        'Coatings krassen, bladderen af en slijten. Dit kookoppervlak is massief titanium — niets dat eraf slijt.': 'Coatings krassen, bladderen en slijten. Dit kookoppervlak is massief titanium — er slijt niets af.',
        'Metal utensils welcome. Dishwasher safe. Up to 540°C. For best results: preheat gradually, use a little cooking fat, and let food release before turning.': 'Metalen keukengerei mag. Vaatwasserbestendig. Tot 540°C. Voor het beste resultaat: voorverwarm geleidelijk, gebruik een beetje kookvet, en laat het eten loskomen voor je keert.',
        "Two solid titanium Chef's Pans in the sizes most home cooks use every week: Small (26 cm) for eggs, sauces, and sides; Medium (28 cm) for steaks, stir-fries, and family portions. No PFAS, PFOA, or PTFE coating.": 'Twee massief titanium Chef’s Pans in de maten die je het meest gebruikt: Small (26 cm) voor eieren, sauzen en bijgerechten; Medium (28 cm) voor steaks, roerbak en familiemaaltijden. Geen PFAS-, PFOA- of PTFE-coating.',
        'Same build as buying the pans separately. The set simply starts you with the two most useful sizes. Metal utensils welcome. Dishwasher safe. Up to 540°C. 25-year warranty. 30-day home trial.': 'Dezelfde opbouw als losse pannen. De set geeft je meteen de twee meest gebruikte maten. Metalen keukengerei mag. Vaatwasserbestendig. Tot 540°C. 25 jaar garantie. 30 dagen thuisproef.',
        "Three solid titanium Chef's Pans covering everyday through batch cooking: Small (26 cm) for eggs, sauces, and sides; Medium (28 cm) for steaks, stir-fries, and family portions; Large (30 cm) for bigger sears, one-pan meals, and cooking for a crowd. No PFAS, PFOA, or PTFE coating.": 'Drie massief titanium Chef’s Pans — van doordeweeks tot grotere porties: Small (26 cm) voor eieren, sauzen en bijgerechten; Medium (28 cm) voor steaks, roerbak en familiemaaltijden; Large (30 cm) voor groter aanbakken, one-pan gerechten en koken voor een groep. Geen PFAS-, PFOA- of PTFE-coating.',
        'Same build as buying the pans separately. The set simply starts you with Small, Medium, and Large so you rarely need to swap mid-recipe. Metal utensils welcome. Dishwasher safe. Up to 540°C. 25-year warranty. 30-day home trial.': 'Dezelfde opbouw als losse pannen. De set geeft je Small, Medium en Large — je wisselt zelden halverwege het recept. Metalen keukengerei mag. Vaatwasserbestendig. Tot 540°C. 25 jaar garantie. 30 dagen thuisproef.',
        'Metal spatula. Still perfect.': 'Metalen spatel. Nog steeds perfect.',
        'Buy once. Cook for decades.': 'Koop één keer. Kook decennia lang.',
        'Buy the set once. Cook for decades.': 'Koop de set één keer. Kook decennia lang.',
        'Nobody told me my pan was the problem.': 'Niemand zei dat mijn pan het probleem was.',
        'Feature': 'Kenmerk',
        'Titanoré Labs': 'Titanoré Labs',
        'Regular pans': 'Gewone pannen',
        '2 pans €115 · 3 pans €168. Solid titanium, no coatings.': '2 pannen €149,50 · 3 pannen €189,50. Massief titanium, geen coatings.',
        '2 pans €119 · 3 pans €179. Solid titanium, no coatings.': '2 pannen €149,50 · 3 pannen €189,50. Massief titanium, geen coatings.',
        '2 pans €129 · 3 pans €168. Solid titanium, no coatings.': '2 pannen €149,50 · 3 pannen €189,50. Massief titanium, geen coatings.',
        '2 pans €134 · 3 pans €179. Solid titanium, no coatings.': '2 pannen €149,50 · 3 pannen €189,50. Massief titanium, geen coatings.',
        '40% SUMMER DISCOUNT': '40% zomerkorting',
        'Shop sets →': 'Bekijk sets →',
        'Browse the collection': 'Bekijk de collectie',
        'No products found.': 'Geen producten gevonden.',
        'First access to new drops': 'Eerste toegang tot nieuwe drops',
        'Care tips & stove notes': 'Verzorgingstips & fornuisnotities',
        'No spam, always unsubscribable': 'Geen spam, altijd uitschrijfbaar',
        'By subscribing, you agree to our privacy policy. Always unsubscribable.': 'Door je in te schrijven ga je akkoord met ons privacybeleid. Altijd uitschrijfbaar.',
        'Most non-stick pans fail because the coating is the product — and coatings scratch, peel, and die. Titanoré Labs builds pans with a solid titanium cooking surface: no PFAS, no PFOA, no PTFE, nothing to wear off.': 'De meeste pannen met antiaanbaklaag falen omdat de coating het product is — coatings krassen, bladderen af en slijten. Titanoré Labs maakt pannen met een massief titanium kookoppervlak: geen PFAS, geen PFOA, geen PTFE, niets dat eraf slijt.',
        'Coated pans shed their non-stick layer into the pan and eventually into the bin. Solid titanium has no coating to peel — so you can cook with metal utensils, take high heat, and keep one pan working instead of rotating a stack of dying non-stick.': 'Gecoate pannen laten hun antiaanbaklaag in de pan achter — en uiteindelijk in de prullenbak. Massief titanium heeft geen coating die afbladdert — je kookt met metalen keukengerei, gaat tot hoge hitte, en houdt één pan in gebruik in plaats van een stapel stervende antiaanbakpannen te rouleren.',
        'Solid titanium cooking surface — not a chemical film': 'Massief titanium kookoppervlak — geen chemische film',
        'No PFAS / PFOA / PTFE coating to scratch or replace': 'Geen PFAS-/PFOA-/PTFE-coating die krast of vervangen moet worden',
        'Metal utensils and high heat welcome; dishwasher safe': 'Metalen keukengerei en hoge hitte welkom; vaatwasserbestendig',
        'One honest pan that replaces the coated cycle': 'Eén eerlijke pan die de gecoate vervangcyclus stopt',
        'Shop the full Titanoré set below — Chef’s Pan sizes and the pieces that belong beside them.': 'Shop hieronder de volledige Titanoré-set — Chef’s Pan-maten en de stukken die ernaast horen.',
        'Chef’s Pan sizes, cutting boards, and everyday titanium accessories.': 'Chef’s Pan-maten, snijplanken en alledaagse titanium accessoires.'
      };
      document.querySelectorAll(
        'h1,h2,h3,h4,h5,p,span,a,button,label,legend,th,td,li,.button-text,.shop-add-to-cart-button,.twt-btn,.okh-mega-feature__tag,.okh-mega-feature__desc,.okh-mega-feature__cta'
      ).forEach(function (el) {
        if (el.closest('script,style,noscript,textarea,svg,#tl-buybox-mock')) return;
        if (el.classList.contains('tsh-btn') || el.closest('.tsh-buttons')) return;
        if (el.querySelector('img,svg,input,select,textarea,button')) return;
        var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!t || !EXACT[t]) return;
        el.setAttribute('data-wg-notranslate', '');
        el.setAttribute('translate', 'no');
        el.textContent = EXACT[t];
      });
      document.querySelectorAll('[class*="preview-text-"], [class*="extra-text-"]').forEach(function (el) {
        var nodes = el.childNodes;
        for (var i = 0; i < nodes.length; i++) {
          if (nodes[i].nodeType !== 3) continue;
          var raw = nodes[i].nodeValue || '';
          var t = raw.replace(/\s+/g, ' ').trim();
          if (!EXACT[t]) continue;
          el.setAttribute('data-wg-notranslate', '');
          el.setAttribute('translate', 'no');
          nodes[i].nodeValue = raw.replace(t, EXACT[t]);
        }
      });
      document.querySelectorAll('button[data-less], button[data-more], [class*="read-more-btn-"]').forEach(function (el) {
        var less = (el.getAttribute('data-less') || '').trim();
        var more = (el.getAttribute('data-more') || '').trim();
        if (EXACT[less]) el.setAttribute('data-less', EXACT[less]);
        if (EXACT[more]) el.setAttribute('data-more', EXACT[more]);
        var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!EXACT[t]) return;
        el.setAttribute('data-wg-notranslate', '');
        el.setAttribute('translate', 'no');
        el.textContent = EXACT[t];
      });
      document.querySelectorAll('input[type="search"], input[name="q"]').forEach(function (el) {
        var ph = (el.getAttribute('placeholder') || '').trim();
        if (ph === 'Search...' || ph === 'Search pans, boards...') {
          el.setAttribute('placeholder', ph.indexOf('pans') >= 0 ? 'Pannen, planken zoeken...' : 'Zoeken...');
          el.setAttribute('aria-label', 'Zoeken');
        }
      });
    }
    var PAN_TITLE_SERIF = {
      'titanium-hammered-pan-pro-small': true,
      'titanium-hammered-pan-pro-medium': true,
      'titanium-hammered-pan-pro-large': true
    };
    var TITLE_SERIF = {
      en: 'Pure titanium.<br>Pure craftsmanship.',
      nl: 'Puur titanium.<br>Puur vakmanschap.'
    };
    var TITLE_SERIF_FLAT = {
      en: 'Pure titanium. Pure craftsmanship.',
      nl: 'Puur titanium. Puur vakmanschap.'
    };
    var TITLE_SUB = {
      en: 'PFAS-free. No coating. Made to last.',
      nl: 'PFAS-vrij. Zonder coating. Gemaakt om te blijven.'
    };
    var TITLE_ICONS = [
      { en: '100% PFAS-free', nl: '100% PFAS-vrij', svg: '<path d="M12 3.4s-5.4 6.6-5.4 11a5.4 5.4 0 0 0 10.8 0c0-4.4-5.4-11-5.4-11z"/>' },
      { en: 'No coating', nl: 'Geen coating', svg: '<circle cx="12" cy="12" r="8"/><path d="M6.8 17.2 17.2 6.8"/>' },
      { en: 'Solid titanium', nl: 'Massief titanium', svg: '<path d="M12 3.4 19 7.5v9L12 20.6 5 16.5v-9L12 3.4z"/>' },
      { en: '25-year warranty', nl: '25 jaar garantie', svg: '<path d="M12 3.5 19.2 6.4v5.8c0 4.2-3.1 6.9-7.2 8.3-4.1-1.4-7.2-4.1-7.2-8.3V6.4L12 3.5z"/>' }
    ];
    function pinNoTranslate(el) {
      if (!el) return;
      el.setAttribute('data-wg-notranslate', '');
      el.setAttribute('translate', 'no');
    }
    function pinPair(el, en, nl) {
      if (!el) return;
      el.setAttribute('data-en', en);
      el.setAttribute('data-nl', nl);
      pinNoTranslate(el);
    }
    function titleIconRowHtml() {
      var lang = isNl() ? 'nl' : 'en';
      return (
        '<ul class="tl-title-icons" aria-label="' +
        (lang === 'nl' ? 'Belangrijkste kenmerken' : 'Key features') +
        '">' +
        TITLE_ICONS.map(function (icon) {
          return (
            '<li><svg viewBox="0 0 24 24" aria-hidden="true">' +
            icon.svg +
            '</svg><span data-en="' +
            icon.en +
            '" data-nl="' +
            icon.nl +
            '" data-wg-notranslate translate="no">' +
            icon[lang] +
            '</span></li>'
          );
        }).join('') +
        '</ul>'
      );
    }
    /* Pan PDP H1 owner: serif stack. Do not flatten to size name. */
    function fixNlTitles2() {
      var path = (location.pathname || '').toLowerCase();
      var pm = path.match(/\/products\/([^/?#]+)/);
      if (!pm || !PAN_TITLE_SERIF[pm[1]]) return;
      var lang = isNl() ? 'nl' : 'en';
      var headline = TITLE_SERIF[lang];
      document.querySelectorAll('h1.shop-product-title, h1.product-title, .shop-product-info h1').forEach(function (el) {
        pinNoTranslate(el);
        el.classList.remove('tl-title-v4');
        el.classList.add('tl-title-serif');
        pinPair(el, TITLE_SERIF_FLAT.en, TITLE_SERIF_FLAT.nl);
        var stack = el.closest('.tl-title-stack');
        if (!stack) {
          stack = document.createElement('header');
          stack.className = 'tl-title-stack';
          pinNoTranslate(stack);
          if (el.parentNode) el.parentNode.insertBefore(stack, el);
          stack.appendChild(el);
        }
        var kickerRow = stack.querySelector('.tl-title-kicker-row');
        if (!kickerRow) {
          kickerRow = document.createElement('div');
          kickerRow.className = 'tl-title-kicker-row';
          kickerRow.innerHTML = '<p class="tl-title-kicker">Chef\'s Pan</p>';
          stack.insertBefore(kickerRow, el);
        }
        pinPair(stack.querySelector('.tl-title-kicker'), "Chef's Pan", "Chef's Pan");
        var flat = (el.textContent || '').replace(/\s+/g, ' ').trim();
        var wantFlat = TITLE_SERIF_FLAT[lang];
        if (flat !== wantFlat) el.innerHTML = headline;
        else if (el.innerHTML.indexOf('<br') === -1) el.innerHTML = headline;
        var sub = stack.querySelector('.tl-title-sub');
        if (!sub) {
          sub = document.createElement('p');
          sub.className = 'tl-title-sub';
          el.insertAdjacentElement('afterend', sub);
        }
        pinPair(sub, TITLE_SUB.en, TITLE_SUB.nl);
        if ((sub.textContent || '').replace(/\s+/g, ' ').trim() !== TITLE_SUB[lang]) {
          sub.textContent = TITLE_SUB[lang];
        }
        if (!stack.querySelector('.tl-title-icons')) {
          sub.insertAdjacentHTML('afterend', titleIconRowHtml());
        }
        var iconSpans = stack.querySelectorAll('.tl-title-icons span');
        iconSpans.forEach(function (span, i) {
          var icon = TITLE_ICONS[i];
          if (!icon) return;
          pinPair(span, icon.en, icon.nl);
          if ((span.textContent || '').trim() !== icon[lang]) span.textContent = icon[lang];
        });
        var leftover = document.getElementById('tl-pan-promise');
        if (leftover && !leftover.classList.contains('tl-title-sub')) leftover.remove();
      });
    }
    function fixNlTitles() {
      if (!isNl()) return;
      document.querySelectorAll('.tsc-card, .product-card, a[href*="/products/"], .twt-card-title a').forEach(function (card) {
        if (card.closest('.tl-slp')) return;
        var href = card.getAttribute('href') || '';
        var handle = handleFromHref(href);
        var nl = TITLE_NL[handle];
        if (!nl) return;
        var titleEl = card.matches('.twt-card-title a') ? card : card.querySelector('.tsc-card__title, .card__heading, .card__title, h2, h3, .twt-card-title a');
        if (!titleEl && card.classList.contains('tsc-card')) return;
        if (titleEl) {
          titleEl.setAttribute('data-wg-notranslate', '');
          titleEl.setAttribute('translate', 'no');
          titleEl.textContent = nl;
        }
      });
      var path = (location.pathname || '').toLowerCase();
      var pm = path.match(/\/products\/([^/?#]+)/);
      if (pm && TITLE_NL[pm[1]] && !PAN_TITLE_SERIF[pm[1]]) {
        document.querySelectorAll('h1, .product__title, .shop-product-title').forEach(function (el) {
          if (el.closest('.tl-board-buy, .tl-board-final, .tl-board-essentials, .tl-ice-fase1, .tl-acc-pdp, .tl-pdp-buy, .tl-p2')) return;
          var t = (el.textContent || '').trim();
          if (!t) return;
          el.setAttribute('data-wg-notranslate', '');
          el.setAttribute('translate', 'no');
          el.textContent = TITLE_NL[pm[1]];
        });
      }
      var cm = path.match(/\/collections\/([^/?#]+)/);
      if (cm && COL_NL[cm[1]]) {
        document.querySelectorAll('.tsc-title, .collection-hero__title, h1').forEach(function (el) {
          if (el.closest('.tl-col-fase1, .tl-acc-fase1, .tl-care-fase1, .tl-ice-fase1') || el.hasAttribute('data-tl-col-h1') || el.hasAttribute('data-tl-acc-h1') || el.hasAttribute('data-tl-care-h1')) return;
          el.setAttribute('data-wg-notranslate', '');
          el.setAttribute('translate', 'no');
          el.textContent = COL_NL[cm[1]];
        });
      }
    }
    function hideWeglotOriginal() {
      if (!isNl()) return;
      document.querySelectorAll('.wg-original, [data-wg-original], .weglot-hide').forEach(function (el) {
        /* Never hide product photos — Weglot tagged real <img> as .wg-original
           and this used to blank the ice-cubes gallery (arrows, no picture). */
        if (el.closest('[data-tcs-root], .titanore-chef-spotlight')) return;
        if (el.matches('img, picture, source, video, svg, canvas')) return;
        if (el.closest('.shop-image-container, .shop-thumbnails, .shop-main-image-wrapper, .product-gallery, .shop-product-carousel, .shop-image-zoom-wrapper, .tl-title-v4, .tl-title-stack, h1.shop-product-title, .tl-ice-gallery, .tl-acc-card__media, .tl-care-fase1, .tl-board-buy, .tl-board-daily, .tl-board-related')) return;
        el.style.setProperty('display', 'none', 'important');
      });
    }
    function fixPanBuyboxNl() {
      if (!isNl()) return;
      var box = document.getElementById('tl-pan-buybox');
      if (!box) return;
      box.querySelectorAll('.wg-original, [data-wg-original], .weglot-hide').forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
      });
      function pin(el, en, nl) {
        if (!el) return;
        el.setAttribute('data-en', en);
        el.setAttribute('data-nl', nl);
        el.setAttribute('data-wg-notranslate', '');
        el.setAttribute('translate', 'no');
        if ((el.textContent || '').replace(/\s+/g, ' ').trim() !== nl) el.textContent = nl;
      }
      pin(box.querySelector('.tl-timer-label'), 'Ends Sunday 6 September', 'Eindigt zondag 6 september');
      pin(box.querySelector('.tl-promise'), 'No coating. Nothing to wear off.', 'Geen coating. Niets dat slijt.');
      pin(box.querySelector('.tl-label--format'), 'Size', 'Formaat');
      pin(box.querySelector('.tl-label--option, .tl-label:not(.tl-label--format)'), 'Choose your option', 'Kies je optie');
      pin(box.querySelector('[data-size-guide]'), 'Which size?', 'Welke maat?');
      var tiles = box.querySelector('.tl-format-tiles');
      if (tiles) tiles.setAttribute('aria-label', 'Formaat');
      var group = box.querySelector('.tl-options');
      if (group) group.setAttribute('aria-label', 'Kies je optie');

      var OPT = {
        single: {
          title: ['This pan', 'Deze pan']
        },
        small: {
          title: ['Small · 26 cm', 'Small · 26 cm'],
          you: ['You get: 1 titanium frying pan — Small (26 cm)', 'Je ontvangt: 1 titanium koekenpan — Small (26 cm)']
        },
        medium: {
          title: ['Medium · 28 cm', 'Medium · 28 cm'],
          you: ['You get: 1 titanium frying pan — Medium (28 cm)', 'Je ontvangt: 1 titanium koekenpan — Medium (28 cm)']
        },
        large: {
          title: ['Large · 30 cm', 'Large · 30 cm'],
          you: ['You get: 1 titanium frying pan — Large (30 cm)', 'Je ontvangt: 1 titanium koekenpan — Large (30 cm)']
        },
        set2: {
          title: ['2 pans', '2 pannen'],
          hook: ['Best choice · 2nd pan for €29', 'Beste keuze · 2e pan voor €29'],
          you: ['26 cm + 28 cm', '26 cm + 28 cm']
        },
        set3: {
          title: ['3 pans', '3 pannen'],
          you: ['26 cm + 28 cm + 30 cm', '26 cm + 28 cm + 30 cm']
        }
      };
      Object.keys(OPT).forEach(function (key) {
        var opt = box.querySelector('.tl-option[data-option="' + key + '"]');
        if (!opt) return;
        var cfg = OPT[key];
        pin(opt.querySelector('.tl-option-title'), cfg.title[0], cfg.title[1]);
        if (cfg.badge) pin(opt.querySelector('.tl-option-badge'), cfg.badge[0], cfg.badge[1]);
        if (cfg.hook) pin(opt.querySelector('.tl-option-hook'), cfg.hook[0], cfg.hook[1]);
        if (cfg.you) pin(opt.querySelector('.tl-option-youget'), cfg.you[0], cfg.you[1]);
      });

      var stock = box.querySelector('[data-stock-status]');
      if (stock && !/uitverkocht|out of stock/i.test(stock.textContent || '')) {
        pin(stock, 'In stock', 'Op voorraad');
      }
      var TRUST_NL = 'Gratis verzending NL & BE · 30 dagen thuisproef · 25 jaar garantie';
      var TRUST_EN = 'Free shipping NL & BE · 30-day home trial · 25-year warranty';
      var trustMap = {
        'Free shipping': TRUST_NL,
        'Free shipping NL & BE · 30-day home trial · 25-year warranty': TRUST_NL,
        'Free returns': TRUST_NL,
        '30-day home trial': TRUST_NL,
        '30 dagen thuis proberen': TRUST_NL,
        'Gratis verzending': TRUST_NL,
        'Gratis retour': TRUST_NL
      };
      box.querySelectorAll('.tl-trust-list li').forEach(function (li) {
        pin(li, TRUST_EN, TRUST_NL);
      });

      var formatLabel = box.querySelector('.tl-label--format');
      if (formatLabel) {
        formatLabel.setAttribute('data-en', 'Size');
        formatLabel.setAttribute('data-nl', 'Formaat');
        formatLabel.setAttribute('data-wg-notranslate', '');
        formatLabel.setAttribute('translate', 'no');
        formatLabel.textContent = 'Formaat';
      }
      var label = box.querySelector('.tl-label--option') || box.querySelector('.tl-label:not(.tl-label--format)');
      if (label) {
        label.setAttribute('data-en', 'Choose your option');
        label.setAttribute('data-nl', 'Kies je optie');
        label.setAttribute('data-wg-notranslate', '');
        label.setAttribute('translate', 'no');
        if ((label.textContent || '').replace(/\s+/g, ' ').trim() !== 'Kies je optie') {
          label.textContent = 'Kies je optie';
        }
      }
      var packs = box.querySelector('.tl-packs');
      if (packs) packs.setAttribute('aria-label', 'Kies aantal');
      box.querySelectorAll('.tl-pack-save, .tl-price-off, .tl-price-note').forEach(function (el) {
        var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!t) return;
        var next = t
          .replace(/off list/ig, 'onder adviesprijs')
          .replace(/List price/ig, 'Adviesprijs')
          .replace(/\bCompare at\b/ig, 'Adviesprijs')
          .replace(/Best value/ig, 'Beste deal')
          .replace(/Complete set/ig, 'Compleet')
          .replace(/Most popular/ig, 'Meest gekozen')
          .replace(/solid titanium/ig, 'massief titanium')
          .replace(/less than buying separately/ig, 'voordeel t.o.v. los')
          .replace(/(\d+)\s+pans/ig, '$1 pannen')
          .replace(/One pan\. Decades of cooking\./i, 'Eén pan. Decennia koken.');
        if (next !== t) {
          el.setAttribute('data-wg-notranslate', '');
          el.setAttribute('translate', 'no');
          el.textContent = next;
        }
      });
      box.querySelectorAll('.tl-slot-label').forEach(function (el) {
        if ((el.textContent || '').trim() === 'Size') {
          el.setAttribute('data-wg-notranslate', '');
          el.setAttribute('translate', 'no');
          el.textContent = 'Maat';
        }
      });
      var cta = box.querySelector('[data-cta], .tl-cta');
      if (cta && !cta.disabled) {
        var ct = (cta.textContent || '').replace(/\s+/g, ' ').trim();
        var nextCta = ct
          .replace(/^Add to cart/i, 'In winkelwagen')
          .replace(/^Add (\d+) pans/i, '$1 pannen in winkelwagen')
          .replace(/^Adding…$/i, 'Bezig…')
          .replace(/^Try again$/i, 'Opnieuw proberen');
        if (nextCta !== ct) {
          cta.setAttribute('data-wg-notranslate', '');
          cta.setAttribute('translate', 'no');
          cta.textContent = nextCta;
        }
      }
      var trust = box.querySelector('.tl-trust');
      if (trust && /Free EU shipping/i.test(trust.textContent || '')) {
        trust.setAttribute('data-wg-notranslate', '');
        trust.setAttribute('translate', 'no');
        trust.textContent = 'Gratis EU-verzending · Gratis retour · Metalen keukengerei welkom';
      }
      var care = box.querySelector('.tl-care');
      if (care && /Free care guide|Cooking/i.test(care.textContent || '')) {
        care.childNodes.forEach(function (n) {
          if (n.nodeType === 3 && /Free care guide/i.test(n.nodeValue || '')) {
            n.nodeValue = (n.nodeValue || '').replace(/Free care guide with every pan/ig, 'Gratis verzorgingsgids bij elke pan');
          }
        });
        var careSpan = care.querySelector('span');
        if (careSpan && /Free care guide/i.test(careSpan.textContent || '')) {
          careSpan.setAttribute('data-wg-notranslate', '');
          careSpan.setAttribute('translate', 'no');
          careSpan.textContent = 'Gratis verzorgingsgids bij elke pan · ';
        }
        var careLink = care.querySelector('a');
        if (careLink && /Cooking/i.test(careLink.textContent || '')) {
          careLink.setAttribute('data-wg-notranslate', '');
          careLink.setAttribute('translate', 'no');
          careLink.textContent = 'Koken & onderhoud';
        }
      }
      var cross = box.querySelector('.tl-cross a');
      if (cross && /Cutting Board|Add a Titanium/i.test(cross.textContent || '')) {
        cross.setAttribute('data-wg-notranslate', '');
        cross.setAttribute('translate', 'no');
        cross.textContent = 'Voeg een titanium snijplank toe →';
      }
    }
    function pinDataNl() {
      if (!isNl()) return;
      document.querySelectorAll('[data-en][data-nl]').forEach(function (el) {
        if (el.closest('script,style,noscript,#tl-buybox-mock,#tl-setu-buybox')) return;
        if (el.classList.contains('tsh-btn') || el.closest('.tsh-buttons')) return;
        if (el.matches('input,textarea,select,option,[data-cta],.tl-cta')) return;
        if (el.children.length && el.querySelector('input,select,textarea,img,svg,button,a')) return;
        var nl = el.getAttribute('data-nl');
        if (nl == null || nl === '') return;
        var cur = (el.textContent || '').replace(/\s+/g, ' ').trim();
        var want = String(nl).replace(/\s+/g, ' ').trim();
        if (cur !== want) el.textContent = nl;
      });
    }
    function pinNlNativeAtc() {
      if (!isNl()) return;
      document.querySelectorAll(
        '.shop-add-to-cart-button, button[name="add"], .product-form__submit, #stickyAddToCart button, .sticky-add-to-cart__button, #tgem-shop-sticky [data-ss-cta], .tgem-sticky__cta'
      ).forEach(function (btn) {
        var persistent = btn.getAttribute('data-persistent-text');
        if (persistent && /^add to cart$/i.test(persistent.replace(/\s+/g, ' ').trim())) {
          btn.setAttribute('data-persistent-text', 'In winkelwagen');
        }
        var textEl = btn.querySelector('.button-text');
        if (textEl) {
          var html = textEl.innerHTML || '';
          if (/Add to [Cc]art/i.test(html)) textEl.innerHTML = html.replace(/Add to [Cc]art/gi, 'In winkelwagen');
          return;
        }
        var plain = (btn.textContent || '').replace(/\s+/g, ' ').trim();
        if (/^Add to cart/i.test(plain)) {
          btn.setAttribute('data-wg-notranslate', '');
          btn.setAttribute('translate', 'no');
          btn.textContent = plain.replace(/^Add to cart/i, 'In winkelwagen');
          return;
        }
        btn.childNodes.forEach(function (n) {
          if (n.nodeType === 3 && /Add to [Cc]art/i.test(n.nodeValue || '')) {
            n.nodeValue = n.nodeValue.replace(/Add to [Cc]art/gi, 'In winkelwagen');
          }
        });
      });
    }
    function rewriteFaqReviews() {
      if (!isNl()) return;
      if (document.querySelector('[data-tl-stack-lp]')) return;
      document.querySelectorAll(
        '.selluxe-faq p, .faq-item p, [class*="faq"] p, [class*="Faq"] p, .jdgm-rev-body, .jdgm-rev, .oke-w-review-content, [class*="review"] p'
      ).forEach(function (el) {
        var html = el.innerHTML || '';
        var next = html
          .replace(/70%\s*SUMMER DISCOUNT/ig, '40% zomerkorting')
          .replace(/60%\s*SUMMER DISCOUNT/ig, '40% zomerkorting')
          .replace(/40%\s*SUMMER DISCOUNT/ig, '40% zomerkorting')
          .replace(/SUMMER DISCOUNT/ig, 'zomerkorting');
        if (next !== html) el.innerHTML = next;
      });
    }
    function rewriteSummerEverywhere() {
      /* Disabled 2026-08-24 — full-document TreeWalker froze NL pan PDPs (black screen). */
      return;
    }
    function stripEnBesideNl() {
      if (!isNl()) return;
      if (document.querySelector('[data-tl-stack-lp]')) return;
      document.querySelectorAll('.tsc-badge, .tss-save, .tob-sale, .tl-price-off, .tl-summer-chip, .okcat-badge').forEach(function (el) {
        var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (el.matches('.tss-save') && /%\s*(OFF|korting)\s*$/i.test(t)) return;
        if (/zomerkorting/i.test(t) && /SUMMER DISCOUNT/i.test(t)) {
          el.textContent = '40% zomerkorting';
        }
      });
    }
    function parseEuro(t) {
      var s = String(t || '').replace(/[^\d,.\-]/g, '');
      if (!s) return NaN;
      if (s.indexOf(',') >= 0 && s.indexOf('.') >= 0) {
        if (s.lastIndexOf(',') > s.lastIndexOf('.')) s = s.replace(/\./g, '').replace(',', '.');
        else s = s.replace(/,/g, '');
      } else if (s.indexOf(',') >= 0) {
        s = s.replace(',', '.');
      }
      return parseFloat(s);
    }
    function formatEuro(n, useComma) {
      var parts = n.toFixed(2).split('.');
      return useComma ? ('€' + parts[0] + ',' + parts[1]) : ('€' + parts[0] + '.' + parts[1]);
    }
    function roundUpNice(raw) {
      var euros = Math.floor(raw + 1e-9);
      var frac = raw - euros;
      if (frac < 0.001) return euros;
      if (frac <= 0.95 + 1e-9) return euros + 0.95;
      return euros + 1;
    }
    function fixCompareAt40() {
      if (document.querySelector('[data-tl-stack-lp]')) return;
      document.querySelectorAll('.tsc-card').forEach(function (card) {
        if (card.closest('cart-drawer, #CartDrawer, .cart-drawer, #main-cart-items')) return;
        var href = (card.getAttribute('href') || '').toLowerCase();
        var priceEl = card.querySelector('.tsc-card__price');
        var wasEl = card.querySelector('.tsc-card__compare');
        var badge = card.querySelector('.tsc-badge');
        if (/chefs-pan-set-3-pans/.test(href)) {
          if (wasEl) wasEl.textContent = '€640';
          if (badge) badge.textContent = isNl() ? '60% korting' : '60% OFF';
          return;
        }
        if (/chefs-pan-set-3/.test(href)) {
          if (wasEl) wasEl.textContent = '€500';
          if (badge) badge.textContent = isNl() ? '62% korting' : '62% OFF';
          return;
        }
        if (/chefs-pan-set-2/.test(href)) {
          if (wasEl) wasEl.textContent = '€325';
          if (badge) badge.textContent = isNl() ? '60% korting' : '60% OFF';
          return;
        }
        if (!priceEl) return;
        var saleTxt = priceEl.textContent || '';
        if (wasEl) saleTxt = saleTxt.replace(wasEl.textContent || '', '');
        var sale = parseEuro(saleTxt);
        if (!(sale > 0)) return;
        var pretty = formatEuro(roundUpNice(sale / 0.6), /,\d/.test(priceEl.textContent || ''));
        if (wasEl) wasEl.textContent = pretty;
      });
    }
    var running = false;
    function run() {
      if (running) return;
      running = true;
      try {
        killDupes();
        if (document.querySelector('[data-tl-stack-lp]')) {
          document.querySelectorAll('.okh-mega-feature__tag, .okh-mob-sale, .tsc-badge').forEach(function (el) {
            var t = (el.textContent || '');
            if (/40%|66%|zomerkorting|SUMMER DISCOUNT/i.test(t)) el.textContent = '';
          });
          document.querySelectorAll('.okh-mega-feature__desc, .tob-sale, .tl-slp').forEach(function (el) {
            if (el.classList.contains('tl-slp')) return;
            var t = el.textContent || '';
            if (t.indexOf('€168') !== -1) el.textContent = t.replace(/€168(?!,)/g, '€189,50');
          });
        }
        stickyChip();
        pinStickyBar();
        stripStickyCtaPrice();
        fixPackNames();
        pinDataNl();
        pinMicrocopyMap();
        pinNlNativeAtc();
        rewriteSaleEnglish();
        rewriteFaqReviews();
        rewriteSummerEverywhere();
        stripEnBesideNl();
        fixNlTitles();
        fixNlTitles2();
        hideWeglotOriginal();
        fixPanBuyboxNl();
        fixCompareAt40();
      } finally {
        running = false;
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    setTimeout(run, 500);
    setTimeout(run, 1500);
    setTimeout(run, 3500);
    /* No MutationObserver / languageChanged hooks — they fought Weglot and froze /nl tabs. */
  } catch (e) {}
})();
/* tl-freeze-fix 2026-08-24 — TreeWalker disabled, no doc MutationObserver */
/* tl-cachebust-20260827-serif — pan PDP H1 is serif stack, not v4 size name */
